import { render, staticRenderFns } from "./BusinessPrivacyPolicyComponent.vue?vue&type=template&id=4519319a&"
import script from "./BusinessPrivacyPolicyComponent.vue?vue&type=script&lang=js&"
export * from "./BusinessPrivacyPolicyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports